import { defineSlotRecipe } from '@chakra-ui/react';

export const avatarSlotRecipe = defineSlotRecipe({
  slots: ['root'],
  variants: {
    variant: {
      solid: {
        root: {
          colorPalette: 'marleyRed',
        },
      },
    },
    size: {
      '2xs': {
        root: {
          width: '20px',
          height: '20px',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'solid',
  },
});

export default avatarSlotRecipe;
